"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSendAddress = addSendAddress;
exports.default = void 0;
exports.deleteSendAddress = deleteSendAddress;
exports.getSendAddressList = getSendAddressList;
exports.updateSendAddress = updateSendAddress;

var _request = _interopRequireDefault(require("@/utils/request"));

function getSendAddressList(params) {
  return (0, _request.default)({
    url: 'api/send-address',
    method: 'get',
    params: params
  });
}

function addSendAddress(data) {
  return (0, _request.default)({
    url: 'api/send-address',
    method: 'post',
    data: data
  });
}

function updateSendAddress(data) {
  return (0, _request.default)({
    url: 'api/send-address',
    method: 'put',
    data: data
  });
}

function deleteSendAddress(id) {
  return (0, _request.default)({
    url: "api/send-address/".concat(id),
    method: 'delete'
  });
}

var _default = {
  getSendAddressList: getSendAddressList,
  addSendAddress: addSendAddress,
  updateSendAddress: updateSendAddress,
  deleteSendAddress: deleteSendAddress
};
exports.default = _default;